import { render, staticRenderFns } from "./ListKids.vue?vue&type=template&id=9250090e&"
import script from "./ListKids.vue?vue&type=script&lang=js&"
export * from "./ListKids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports